import React from 'react';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import Lottie from 'react-lottie-player';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseOrderDescription } from '../../utils/manager/order-manager';
import cancelIconData from './cancel-icon.json';
import waiterIconData from './waiter-icon.json';

function CancelOrderModalBody({ order, closed, spot }) {
  const classes = useStyles({ closed });
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <Lottie
        play
        // loop={!closed}
        loop
        animationData={closed ? waiterIconData : cancelIconData}
        // animationData={waiterIconData}
        className={classes.icon}
      />

      <FadeIn>
        <div className={classes.title}>
          {t(spot?.prepaid ? 'bill.cancel.to-remove' : 'bill.cancel.canceling')}
        </div>

        <div className={classes.description}>
          {closed
            ? t('bill.cancel.request-cancel')
            : parseOrderDescription(order)}
        </div>
      </FadeIn>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // border: '1px solid white',
  },
  title: {
    fontSize: layoutDefaults.biggestFontSize,
    fontWeight: 'bold',
    marginBottom: layoutDefaults.smallerVerticalMargin,
  },
  description: {
    fontSize: layoutDefaults.fontSize,
    // opacity: layoutDefaults.opacity,
    marginBottom: layoutDefaults.verticalMargin,
  },
  icon: {
    marginBottom: ({ closed }) => closed && -110,
    height: ({ closed }) => (closed ? 280 : 120),
  },
});

export { CancelOrderModalBody };
